var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"food-ingredients",style:({ 'color': _vm.config.ColorContent,
    'font-size': (((_vm.config.FontSizeContent - 5)) + "px"),
    'font-family': _vm.config.FontContent, 
  })},[_vm._v(" "+_vm._s(_vm.ingredients)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }